<template lang="html">
  <div class="content">
    <div class="header">
      <search :params.sync="params" :showCharts="showCharts" :disabled="['type']" />
      <div class="info">
        <span class="color-info">请求URL：</span>
        <a class="color-primary mr" :href="title">{{title}}</a>
        <span class="color-info">请求方式：</span>
        <span class="color-primary mr">{{method}}</span>
        <span class="color-info">错误量：</span>
        <span class="color-primary mr">{{total}}</span>
      </div>
    </div>
    <div class="chart" ref="chart"></div>
  </div>
</template>

<script>
import moment from "moment";
import axios from "axios";
import qs from "qs";

import tool from "utils/tool";

import search from '../../components/search';

export default {
  components: {
    search
  },
  data() {
    return {
      params: {},
      total: 0
    };
  },
  computed: {
    title: function() {
      return tool.getUrlParams('url')
    },
    method: function() {
      return tool.getUrlParams('method')
    }
  },
  mounted() {
    this.chart = echarts.init(this.$refs.chart, 'light');

    window.addEventListener("resize", () => {
      this.chart.resize();
    });
  },
  beforeDestroy() {
    this.$bus.$off("clientChange");
  },
  methods: {
    showCharts() {
      this.loading = true;
      this.fetchList().then(values => {
        this.loading = false;
      });
    },
    fetchList() {
      const { clientType, dateRange } = this.params;
      const query = {
        client: clientType,
        match: JSON.stringify({ url: tool.getUrlParams("url"), method: tool.getUrlParams("method") }),
        dateRange
      };

      return axios
        .get(`/ajax/detail?${qs.stringify(query)}`)
        .then(response => {
          const { data } = response.data;

          const { times } = data;

          this.total = times.reduce((prev, cur) => {
            return prev + cur.doc_count
          }, 0)

          const ajaxCountSeries = [];

          // const allStatus = [200, 404, 500, 502, 0]

          // 动态获取当前所有的状态类型
          const allStatus = Array.from(new Set(times.reduce((prev, el) => {
            return prev.concat(el.status_count.map(status => status.key))
          }, []))).filter(el => el !== 200)

          allStatus.sort((a, b) => {
            if (a === 0) return 1;
            if (b === 0) return -1;
            return a - b;
          })

          times.map(row => {
            allStatus.map(status => {

              const doc_count_obj = row.status_count.find(s => s.key === status);
              const doc_count = doc_count_obj ? doc_count_obj.doc_count : 0; // 如果时段没有该状态码的请求，则自动用0补全

              const serie = ajaxCountSeries.find(serie => serie.name === status)
              if (serie) {
                serie.data.push(doc_count)
              } else {
                ajaxCountSeries.push({
                  name: status,
                  type: 'bar',
                  stack: 'doc_count',
                  data: [doc_count]
                })
              }
            })
          });

          // const colors = ajaxCountSeries.map(el => {
          //   return el.name === 200 ? '#9BCA63' : el.name === 404 ? '#FFB248' : el.name === 0 ? '#909399' : '#C42E34'
          // });

          this.chart.setOption({
            // color: colors,
            grid: {
              left: 20,
              right: 10,
              containLabel: true
            },
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "cross",
                crossStyle: {
                  color: "#999"
                }
              }
            },
            legend: {
              data: [
                ...ajaxCountSeries.map(el => `${el.name}`)
              ]
            },
            xAxis: [
              {
                type: "category",
                data: times.map(el => el.key_as_string.replace(' ', '\n')),
                axisPointer: {
                  type: "shadow"
                }
              }
            ],
            yAxis: [
              {
                type: "value",
                name: "AJAX调用量",
                axisLabel: {
                  formatter: "{value}"
                }
              }
            ],
            series: [
              ...ajaxCountSeries
            ]
          });
        })
    }
  }
};
</script>

<style scoped>
.content {
  padding: 30px;
}
.header{
  margin-bottom: 30px;
}
.chart{
  height: 500px;
}
.mr {
  margin-right: 5px;
}
.info{
  margin-top: 30px;
}
</style>
